import { ToolBarProps } from "../utils/interface/HSM";

export const HSMToolBar = ({ children }: ToolBarProps) => {
  return (
    <div className="toolbar">
      <div className="me-auto">{children}</div>
    </div>
  );
};
